<template>
  <div class="slideBox stream-duration" :class="this.$route.query.source">

    <div class="slideHeader">
      <h1>
        <span class="source">{{ this.$route.query.sourceTitle }}</span>
        Hördauer pro Aggregator
      </h1>
      <div class="day">
        <span class="day-range-firstValue">Letzte 7 Tage</span>
        <span class="day-range-divider"></span>
        <span class="day-range-secondValue">7 Tage zuvor</span>
      </div>
    </div>

    <div class="totalValuesWrapper">

      <div class="total-value stream-duration-total-homepage">
        <div class="big value">
          <i-count-up
            :start="0"
            :end="totalValueHomepageEnd"
            :duration="countDuration"
            :decimals="1"
            :options="options"
          ></i-count-up>
          <span class="unit">min</span>
        </div>
        <div class="source-difference" :class="differenceHomepage < 0 ? 'down' : 'up'">
          <span class="source-difference-type">
            Homepage
          </span>
          <span class="source-difference-value">
            <i-count-up
              :start="0"
              :end="differenceHomepage"
              :duration="countDuration"
              :decimals="1"
              :options="options"
            ></i-count-up>
          </span>
        </div>
      </div>

      <div class="total-value stream-duration-total-app">
        <div class="big value">
          <i-count-up
            :start="0"
            :end="totalValueAppEnd"
            :duration="countDuration"
            :decimals="1"
            :options="options"
          ></i-count-up>
          <span class="unit">min</span>
        </div>
        <div class="source-difference" :class="differenceApp < 0 ? 'down' : 'up'">
          <span class="source-difference-type">
            App
          </span>
          <span class="source-difference-value">
            <i-count-up
              :start="0"
              :end="differenceApp"
              :duration="countDuration"
              :decimals="1"
              :options="options"
            ></i-count-up>
          </span>
        </div>
      </div>

    </div>

    <div class="circles">

      <transition name="swap-in" appear>
        <div class="total-value circle stream-duration-total-radiode">
          <div class="big value">
            {{ totalValueRadiodeEnd.toString().replace('.', ',') }}
            <span class="unit">min</span>
          </div>
          <div class="source-difference" :class="differenceRadiode < 0 ? 'down' : 'up'">
            <span class="source-difference-type">
              radio.de
            </span>
            <span class="source-difference-value">
              {{ differenceRadiode.toString().replace('.', ',') }}
            </span>
          </div>
        </div>
      </transition>

      <transition name="swap-in" appear>
        <div class="total-value circle stream-duration-total-vtuner">
          <div class="big value">
            {{ totalValueVtunerEnd.toString().replace('.', ',') }}
            <span class="unit">min</span>
          </div>
          <div class="source-difference" :class="differenceVtuner < 0 ? 'down' : 'up'">
            <span class="source-difference-type">
              vTuner
            </span>
            <span class="source-difference-value">
              {{ differenceVtuner.toString().replace('.', ',') }}
            </span>
          </div>
        </div>
      </transition>

      <transition name="swap-in" appear>
        <div class="total-value circle stream-duration-total-tunein">
          <div class="big value">
            {{ totalValueTuneinEnd.toString().replace('.', ',') }}
            <span class="unit">min</span>
          </div>
          <div class="source-difference" :class="differenceTunein < 0 ? 'down' : 'up'">
            <span class="source-difference-type">
              TuneIn
            </span>
            <span class="source-difference-value">
              {{ differenceTunein.toString().replace('.', ',') }}
            </span>
          </div>
        </div>
      </transition>

    </div>

  </div>
</template>

<script>
import ICountUp from 'vue-countup-v2'
import _ from 'lodash'

export default {
  name: 'stream-duration',
  components: {
    ICountUp
  },
  data () {
    return {
      countDuration: this.$store.state.countDuration,
      totalValueHomepageEnd: 0,
      totalValueAppEnd: 0,
      totalValueRadiodeEnd: 0,
      totalValueTuneinEnd: 0,
      totalValueVtunerEnd: 0,
      differenceHomepage: 0,
      differenceApp: 0,
      differenceRadiode: 0,
      differenceTunein: 0,
      differenceVtuner: 0,
      options: {
        useEasing: true,
        useGrouping: true,
        decimal: ','
      }
    }
  },
  mounted () {
    const theme = this.$route.query.theme
    const source = this.$route.query.source
    const urlPart = theme + '-' + source + '_stream_duration'

    /* total value homepage */
    const totalValueHomepageURL = urlPart + '_homepage-last_7_days_vs_prev_7_days'
    this.axios.get(totalValueHomepageURL).then((response) => {
      const results = _.head(response.data.results)
      this.totalValueHomepageEnd = parseFloat(results.total_value)
      this.differenceHomepage = parseFloat(results.difference)
    })

    /* total value app */
    const totalValueAppURL = urlPart + '_app-last_7_days_vs_prev_7_days'
    this.axios.get(totalValueAppURL).then((response) => {
      const results = _.head(response.data.results)
      this.totalValueAppEnd = parseFloat(results.total_value)
      this.differenceApp = parseFloat(results.difference)
    })

    /* total value radio.de */
    const totalValueRadiodeURL = urlPart + '_radiode-last_7_days_vs_prev_7_days'
    this.axios.get(totalValueRadiodeURL).then((response) => {
      const results = _.head(response.data.results)
      this.totalValueRadiodeEnd = parseFloat(results.total_value).toFixed(1)
      this.differenceRadiode = parseFloat(results.difference).toFixed(1)
    })

    /* total value vTuner */
    const totalValueVtunerURL = urlPart + '_vtuner-last_7_days_vs_prev_7_days'
    this.axios.get(totalValueVtunerURL).then((response) => {
      const results = _.head(response.data.results)
      this.totalValueVtunerEnd = parseFloat(results.total_value).toFixed(1)
      this.differenceVtuner = parseFloat(results.difference).toFixed(1)
    })

    /* total value TuneIn */
    const totalValueTuneinURL = urlPart + '_tunein-last_7_days_vs_prev_7_days'
    this.axios.get(totalValueTuneinURL).then((response) => {
      const results = _.head(response.data.results)
      this.totalValueTuneinEnd = parseFloat(results.total_value).toFixed(1)
      this.differenceTunein = parseFloat(results.difference).toFixed(1)
    })
  }
}
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/stream-duration.vue